<script>
export default {
	data: function(){
		return {
			m_arrErrMsg: [],
			m_arrInfoMsg: [],
			m_arrInitialMsg: [],
			m_bMsgClear: true,
		};
	},
	computed:{
		err_msg: function(){
			return this.m_arrErrMsg;
		},
		info_msg: function(){
			return this.m_arrInfoMsg;
		},
		initial_msg: function(){
			return this.m_arrInitialMsg;
		},
	},
	methods: {
		// 共通処理
		addErrMsg: function( msg ) {
//console.log("addErrMsg : ");
//console.log(msg);
			this.m_arrErrMsg.unshift(msg);
		},
		addInfoMsg: function( msg ) {
//console.log("addInfoMsg");
			this.m_arrInfoMsg.unshift(msg);
		},
		addInitialMsg: function( msg ) {
//console.log("addInitialMsg");
			this.m_arrInitialMsg.unshift(msg);
		},
		clearMsg: function(){
//console.log("clearMsg");
			if ( this.m_bMsgClear ) {
				this.m_arrErrMsg = [];
				this.m_arrInfoMsg= [];
			} else {
				this.m_bMsgClear = true;
			}
		},
		nextMsgNotClear: function(){
			this.m_bMsgClear = false;
		}
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/message.mixin.vue